<template>
  <div class="full-screen" style="z-index: 10;">
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">支付</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>
    <iframe style="width: 100vw;height:100vh;margin-top: 2.5rem" :src="payUrl">
    </iframe>
  </div>
</template>

<script>

  export default {
    name: "user-purchase-pay",
    data() {
      return {
        payUrl: ''
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      }
    },
    mounted() {
      this.$router.isBack = true;
      if (typeof(this.$route.params) == "undefined" || this.$route.params == null){
        this.returnPage();
      }
      this.payUrl = this.$route.params.goUrl;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/pay.vue